module.exports = __webpack_public_path__ + "img/transformer.ce7121c9.png";